(() => {
  const config = document.currentScript?.dataset;
  const destination = '#banner-bundle';
  if (!config || !document.querySelector(destination) || window.swapwearHomepageBaseLinks) return;
  window.swapwearHomepageBaseLinks = true;
  const handles = new Set((config.baseHandles || '').split(',').map(value => value.trim()).filter(Boolean));
  const hosts = new Set([location.host, ...(config.storeHosts || '').split(',')]);
  const rewriteLink = link => {
    if (link.closest('nav, [role="navigation"], #shopify-section-theme__menu')) return;
    const href = link.getAttribute('href');
    if (!href || href === destination) return;
    let url;
    try { url = new URL(href, location.href); } catch (_) { return; }
    if (!['http:', 'https:'].includes(url.protocol) || !hosts.has(url.host)) return;
    const product = url.pathname.match(/\/products\/([^/]+)\/?$/);
    if (!/\/collections\/bases\/?$/.test(url.pathname) && !(product && handles.has(product[1]))) return;
    link.setAttribute('href', destination);
  };
  const rewriteTree = root => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('a[href]')) rewriteLink(root);
    root.querySelectorAll('a[href]').forEach(rewriteLink);
  };
  if (config.mode !== 'preview') {
    rewriteTree(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') rewriteLink(record.target);
        else record.addedNodes.forEach(rewriteTree);
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (link?.getAttribute('href') === destination) {
      window.dispatchEvent(new CustomEvent('homepage:choose-base'));
      if (link.dataset.homepageBase) window.dispatchEvent(new CustomEvent('homepage:select-base', { detail: { handle: link.dataset.homepageBase } }));
    }
  });
})();
